import { render, staticRenderFns } from "./PlayerBatch.vue?vue&type=template&id=1f205d68&"
import script from "./PlayerBatch.vue?vue&type=script&lang=js&"
export * from "./PlayerBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports